var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF00;}\r\n\t.st1{display:none;fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84,480h328c19.9,0,36-16.1,36-36l0,0c0-19.9-16.1-36-36-36h-3.1c-8,0-15.4-5.4-16.6-13.3 c-1.6-10,6.1-18.7,15.8-18.7h42.3c18.8,0,35.6-13.6,37.5-32.3C490,322.3,473,304,452,304h-27.1c-8,0-15.4-5.4-16.6-13.3 c-1.6-10,6.1-18.7,15.8-18.7h41.9c22.9,0,43.5-16.7,45.8-39.5c2.6-26.2-18.1-48.5-43.8-48.5h-98.6c-13,0-24.6-9.7-25.3-22.7 c-0.7-13.8,10.3-25.3,24-25.3h17.9c22.9,0,43.5-16.7,45.8-39.5C434.4,70.3,413.7,48,388,48H84c-24.3,0-44,19.7-44,44l0,0 c0,24.3,19.7,44,44,44h28c8.8,0,16,7.2,16,16l0,0c0,8.8-7.2,16-16,16H37.7c-18.8,0-35.6,13.6-37.5,32.3C-2,221.7,15,240,36,240h66.6 c13,0,24.6,9.7,25.3,22.7c0.7,13.8-10.3,25.3-24,25.3H61.7c-18.8,0-35.6,13.6-37.5,32.3C22,341.7,39,360,60,360h51.1 c8,0,15.4,5.4,16.6,13.3c1.6,10-6.1,18.7-15.8,18.7H84c-24.3,0-44,19.7-44,44l0,0C40,460.3,59.7,480,84,480z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.3749,
    y1: 571.523,
    x2: -10.3749,
    y2: 613.523,
    gradientTransform: "matrix(8 0 0 -8 343 5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.3,152.5c-11.5,3.9-24,6.2-37.1,7.6c12.9-6.4,21.9-15.9,30.2-27.5c4.8-6.6-2.6-15.3-10-11.8 c-13.1,6.3-25.8,11.1-41.7,13.8c-15.6-14-36.2-22.6-58.8-22.6c-32.9,0-61.5,18-76.6,44.6c-7.3,12.8-11.4,27.6-11.4,43.4 c0,5.4,0.7,10.7,1.6,15.8c-70.7-2.1-130-38.6-163.7-84.5c-3.7-5.1-11.6-4-13.9,1.9c-3.6,9-8,18.9-8,34.9c0,1,0,1.8,0.1,2.7 c0.3,10.4,2.6,20.3,6.6,29.3c7.5,17.4,21.1,31.5,38.2,39.8c-1.6,0.1-3.2,0.2-4.9,0.2c-16,0-21.3-5.5-29.9-7.7 c-5.5-1.4-10.8,3.1-10,8.7c2.6,17.8,11.9,36.5,24.2,48.4c13.3,13,31,21.3,50.8,22.5c-10.6,5.2-22.5,8.2-35.1,8.2h-8 c-6,0-9.8,6.4-7.1,11.8c13.4,26.5,44.5,44.2,77.8,44.1C142.6,396.1,104.7,408,64,408h-8c-4.4,0-8,3.6-8,8c0,3.7,2.5,6.6,5.9,7.6 l0,0.1c0,0,60.2,24.3,130.1,24.3c135.4,0,245.5-108.6,247.9-243.4c0.1-1.5,0.1-3,0.1-4.6s0-3-0.1-4.6c-0.1-2.2-0.4-4.4-0.7-6.5 c14.8-4.7,28-12.5,38.5-23.4C475.5,159.5,469.2,149.8,461.3,152.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.0007,
    y1: 264,
    x2: 466.0006,
    y2: 264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.5,136.8l33.5-32.1v-7H349.9l-82.7,205.9L173,97.7H51.3v7l39.1,47.1c3.8,3.5,5.8,8.6,5.3,13.7v185.2 c1.2,6.7-1,13.5-5.7,18.4L46,422.6v6.9h125v-7l-44.1-53.4c-4.8-4.9-7-11.6-6.1-18.4V190.6l109.8,239h12.8l94.4-239V381 c0,5,0,6.1-3.3,9.3l-34,32.8v7h164.7v-7l-32.7-32c-2.9-2.2-4.4-5.8-3.7-9.3V146.2C428.1,142.6,429.6,139,432.5,136.8L432.5,136.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d6c53379332982b02ee2721fc64f5ac5.svg";
export { ForwardRef as ReactComponent };